import React, { Fragment, useState } from 'react'
import { Expaned, Column, Row } from '@/components/layout/layout'
import { Table } from 'antd'
import classNames from 'classnames'
import { getBEMCls } from '@/utils/classname'
import { useFormikContext, FieldArray } from 'formik'
import Input from '@/components/input/input'
import { useCheckForm } from '@/utils/form'
import { INPUT_NUMBER_LIMIT_REGEXP, INPUT_PRICE_LIMIT_REGEXP, WithInputLimit } from '@/utils'
import { ColumnType } from 'antd/es/table'
import { IPakageForm } from '../../package-type'
import FormItem from '@/views/main/modules/goods-manage/components/form/form-item/form-item'
import { showLayer } from '@/utils/layer'
import ChooseGoodsUnitDialog from '../../../edit-goods/modules/goods-unit/goods-unit'
import { goodsModel } from '../../../edit-goods/modules/model'
import { useUpdateEffect } from 'ahooks'

interface PriceTableProps {
    pricingMethodIndex: number
    saleUnitName: string
    saleUnitId: number
    onUnitChange?: (unit: string) => void
}

const PriceTable: React.FC<PriceTableProps> = props => {
    const cls = (...args: string[]) => getBEMCls('edit-package', ...args)
    const { values, handleBlur, handleChange, setFieldValue } = useFormikContext<IPakageForm>()

    const { checkError, getErrorStr } = useCheckForm<IPakageForm>()
    const [unitName, setUnitName] = useState<string>(() => props.saleUnitName)
    const [unitId, setUnitId] = useState<number>(() => props.saleUnitId)

    useUpdateEffect(() => {
        props.onUnitChange && props.onUnitChange(unitName)
    }, [unitName])

    const showUnitLayer = () => {
        showLayer(
            <ChooseGoodsUnitDialog
                goodsModel={goodsModel}
                choosedId={unitId}
                onChange={params => {
                    setUnitName(params.name)
                    setUnitId(params.id)
                    const saleUnit = values.pricing_methods[0].sale_prices.map(o => ({
                        ...o,
                        sale_unit: params.id,
                    }))
                    setFieldValue(`pricing_methods[0]`, {
                        ...values.pricing_methods[0],
                        sales_unit_id: params.id,
                        member_price: {
                            ...values.pricing_methods[0].member_price,
                            sale_unit: params.id,
                        },
                        sale_prices: saleUnit,
                    })
                }}
            />,
        )
    }

    return (
        <FieldArray name={`pricing_methods[${props.pricingMethodIndex}].sale_prices`}>
            {salePricesArrayHelpers => {
                const columns: ColumnType<any>[] = [
                    {
                        title: '档位',
                        dataIndex: '',
                        align: 'center',
                        render: (text, record, index) => {
                            return (
                                <span data-center data-font-weight-600 data-color-000>
                                    {['一', '二', '三'][index]}级
                                </span>
                            )
                        },
                    },
                    {
                        title: '购买量',
                        align: 'center',
                        render: (text, record, index) => {
                            return (
                                <Fragment>
                                    {index === 0 ? (
                                        <span>{'>='}0</span>
                                    ) : (
                                        <Column>
                                            <Row data-justify-content-center>
                                                <span>{'>='}</span>
                                                {WithInputLimit(
                                                    <input
                                                        // tslint:disable-next-line:max-line-length
                                                        name={`pricing_methods[${props.pricingMethodIndex}].sale_prices[${index}].threshold`}
                                                        // tslint:disable-next-line:max-line-length
                                                        value={
                                                            values.pricing_methods[props.pricingMethodIndex]
                                                                .sale_prices[index].threshold
                                                        }
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="请输入"
                                                        className={cls('table', 'ipt')}
                                                        data-width-50
                                                        type="text"
                                                    />,
                                                    INPUT_NUMBER_LIMIT_REGEXP,
                                                )}
                                                <span>{unitName}</span>
                                            </Row>
                                            <span data-padding-top-8 className={classNames(cls('form-item', 'error'))}>
                                                {getErrorStr(
                                                    `pricing_methods[${props.pricingMethodIndex}].sale_prices[${index}].threshold`,
                                                )}
                                            </span>
                                        </Column>
                                    )}
                                </Fragment>
                            )
                        },
                    },
                    {
                        title: '单价',
                        dataIndex: '',
                        render: (text, record, index) => {
                            return (
                                <Fragment>
                                    {
                                        <Column>
                                            <Row data-justify-content-center data-align-items-center>
                                                {WithInputLimit(
                                                    <input
                                                        // tslint:disable-next-line:max-line-length
                                                        name={`pricing_methods[${props.pricingMethodIndex}].sale_prices[${index}].sale_price`}
                                                        // tslint:disable-next-line:max-line-length
                                                        value={
                                                            values.pricing_methods[props.pricingMethodIndex]
                                                                .sale_prices[index].sale_price
                                                        }
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="请输入"
                                                        className={cls('table', 'ipt')}
                                                        data-width-50
                                                        type="text"
                                                    />,
                                                    INPUT_PRICE_LIMIT_REGEXP,
                                                )}
                                                <span
                                                    data-cursor-pointer
                                                    data-position-relative
                                                    onClick={showUnitLayer}
                                                >
                                                    元/{unitName}
                                                    <div className="unit-check" />
                                                </span>
                                            </Row>
                                            <span data-padding-top-8 className={classNames(cls('form-item', 'error'))}>
                                                {getErrorStr(
                                                    `pricing_methods[${props.pricingMethodIndex}].sale_prices[${index}].sale_price`,
                                                )}
                                            </span>
                                        </Column>
                                    }
                                </Fragment>
                            )
                        },
                    },
                    {
                        title: '',
                        dataIndex: '',
                        render: (text, record, index) => {
                            return index === 0 ? null : (
                                <Row
                                    data-justify-content-center
                                    onClick={() => {
                                        salePricesArrayHelpers.remove(index)
                                    }}
                                >
                                    <i style={{ color: '#f00' }} className="iconfont icon6yichu-20"></i>
                                </Row>
                            )
                        },
                    },
                ]

                return values.pricing_methods[props.pricingMethodIndex].sale_prices.length === 1 ? (
                    <Fragment>
                        <Row data-align-items-center>
                            <Column data-expaned>
                                {/* <Row data-align-items-center data-expaned data-position-relative> */}
                                <FormItem
                                    title="参考售价"
                                    isRequire
                                    error={getErrorStr(
                                        `pricing_methods[${props.pricingMethodIndex}].sale_prices[0].sale_price`,
                                    )}
                                >
                                    <Input
                                        error={checkError(
                                            `pricing_methods[${props.pricingMethodIndex}].sale_prices[0].sale_price`,
                                        )}
                                        reg={INPUT_PRICE_LIMIT_REGEXP}
                                        name={`pricing_methods[${props.pricingMethodIndex}].sale_prices[0].sale_price`}
                                        value={
                                            values.pricing_methods[props.pricingMethodIndex].sale_prices[0]
                                                .sale_price || ''
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="请输入"
                                        inputsuffix={() => {
                                            return (
                                                <Row
                                                    data-cursor-pointer
                                                    data-algin-items-center
                                                    onClick={showUnitLayer}
                                                    data-position-relative
                                                >
                                                    <span data-font-size-14 data-color-000>
                                                        元/{unitName}
                                                    </span>
                                                    <div className="unit-check" />
                                                </Row>
                                            )
                                        }}
                                    ></Input>
                                </FormItem>
                            </Column>
                        </Row>

                        <Row data-align-items-center data-height-50 data-padding-h-24>
                            <span
                                data-color-999
                                data-font-weight-400
                                className={classNames(cls('form-item', 'title'))}
                            ></span>
                            <Row
                                onClick={() => {
                                    salePricesArrayHelpers.push({
                                        sale_price: '',
                                        threshold: '',
                                        sale_unit: {
                                            id: 2,
                                            name: unitName,
                                            status: 0,
                                        },
                                    })
                                }}
                                data-align-items-center
                                data-expaned
                                data-position-relative
                            >
                                <span className="text-btn-blue">+新增阶梯价</span>
                            </Row>
                        </Row>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Row data-margin-top-16>
                            <FormItem title="参考售价" isRequire isCenter={false}>
                                <Expaned>
                                    <Table
                                        bordered
                                        rowKey={data => data.sale_price.id}
                                        pagination={false}
                                        columns={columns}
                                        dataSource={values.pricing_methods[props.pricingMethodIndex].sale_prices}
                                        footer={() => {
                                            // tslint:disable-next-line:max-line-length
                                            return values.pricing_methods[props.pricingMethodIndex].sale_prices.length <
                                                3 ? (
                                                <Row
                                                    data-align-items-center
                                                    data-justify-content-center
                                                    data-expaned
                                                    onClick={() => {
                                                        salePricesArrayHelpers.push({
                                                            sale_price: '',
                                                            threshold: '',
                                                            sale_unit: {
                                                                id: 2,
                                                                name: unitName,
                                                                status: 0,
                                                            },
                                                        })
                                                    }}
                                                >
                                                    <span className="text-btn-blue">+新增阶梯价</span>
                                                </Row>
                                            ) : (
                                                false
                                            )
                                        }}
                                    ></Table>
                                </Expaned>
                            </FormItem>
                        </Row>
                    </Fragment>
                )
            }}
        </FieldArray>
    )
}

export default PriceTable
